import getTilePositionFromRowPosition from "../../helpers/getTilePositionFromRowPosition";
import LoyaltyMembersDayBanner from "../../containers/MembersDay";
import config from "../../config/common";

const addLoyaltyMembersDayBanner = ({
  viewportCategory,
  positionFinder,
  items
}) => {
  const {
    loyalty: { membersDayInsertAtRow }
  } = config;

  const outputItems = [...items];

  const targetPosition = getTilePositionFromRowPosition({
    viewportCategory,
    rowPosition: membersDayInsertAtRow
  });

  const targetIndexInItemsArray = positionFinder({
    configuredPosition: targetPosition,
    items: [...outputItems]
  });

  if (targetIndexInItemsArray >= outputItems.length) {
    return outputItems;
  }

  outputItems.splice(
    targetIndexInItemsArray,
    0,
    <LoyaltyMembersDayBanner key="loyaltyMembersDayBanner" />
  );

  return outputItems;
};

export default addLoyaltyMembersDayBanner;
